import React from 'react';

export const AppContext = React.createContext({
    wsConnected: false,
    wsConnectTime: null,
    wsDisconnectTime: null
});